import { Slot } from "expo-router";

export default function SiteAlarmSettingsWebLayout() {
  return <Slot />;
}
